<style>
@import '../../assets/css/account.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <form @submit.prevent="initialize" :submit="initialize">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_ip_address')}}</template>
                            <el-input v-model="ajaxSearch.ip" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label"></template>
                            <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                        </b-form-group>
                    </form>
                </b-card>
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" v-b-modal.addBlockIp v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('account_block_ip.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">            
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteBlockIp()" v-if="permissionList.includes(permission.delete)">{{$t('account_block_ip.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>

                <b-modal id="addBlockIp" :title="$t('account_block_ip.table_add')" @ok="addBlockIp" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addBlockIpForm" @submit.prevent="addBlockIp()">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_ip_address')}}</template>
                            <b-form-input name="ip"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_remark')}}</template>
                            <b-form-input name="remark"></b-form-input>
                        </b-form-group>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {blockIpAjaxTable,blockIpSearch,blockIpAdd,blockIpDelete} from '@/system/model/account'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';
export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',created_at:'',ip:'',remark:''},
            ajaxAdd:{status:1,value:0},
            ajaxRow:'',
            ajaxInfo:[],
            ajaxEdit:[],
            statusList:[],
            tabIndex:1,
            pageLimit:10,
            permission:{
                add: 'ADDF96',
                delete:'00BFF5'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'80'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'180'
            },{
                prop: "ip",
                label: this.$t('admin.table_ip_address'),
                width:'150'
            },{
                prop: "remark",
                label: this.$t('admin.table_remark'),
                width:'150'       
            }],        
        }
    },methods:{
        initialize(){
            var self = this;
            var result = blockIpAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.created_at,this.ajaxSearch.ip,this.ajaxSearch.remark);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.statusList = value.data.status_list;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },addBlockIp(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                var form = document.getElementById('addBlockIpForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = blockIpAdd(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();
                                self.$bvModal.hide('addBlockIp');
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();
                                self.$bvModal.hide('addBlockIp');
                            }
                        });
                    }
                });
            }
        },deleteBlockIp(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = blockIpDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
